
import React, { useState } from "react";
import {
  Box,
  Stack,
  Grid,
  Tab,
  Tabs,
} from "@mui/material";
import TopSection from "../../Components/Common/Top/TopSection";
import AccessRequest from "./AccessRequest";
import AccessTracker from "./AccessTracker";

const AccessManagement = () => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (event, newValue) => setActiveTab(newValue);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Access Management", path: "/access-Management" },
                { title: "Access Management" },
              ]}
              title="Access Management"
            />
            <div class="container">
              {/* <AccessRequest /> */}
              <Box>
                <Tabs value={activeTab} onChange={handleTabChange}
                  sx={{
                    "& .MuiTab-root": {
                      textTransform: "none",
                      fontSize: "14px",
                      fontWeight: 500,
                      minWidth: "200px",
                    },
                  }}>
                  <Tab label="Access Request" />
                  <Tab label="Access Tracker" />
                </Tabs>

                {activeTab === 0 && <Box><AccessRequest /></Box>}
                {activeTab === 1 && <Box><AccessTracker /></Box>}
              </Box>
            </div>
            
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default AccessManagement;

